"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _zIndex = _interopRequireWildcard(require("pubweb-smokey/dist/components/zIndex"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

_zIndex.default.baseLine = (0, _zIndex.setAbove)(1);
_zIndex.default.loadingIndicator = (0, _zIndex.setAbove)();
_zIndex.default.sliderControls = (0, _zIndex.setAbove)();
_zIndex.default.livePerson = (0, _zIndex.setAbove)();
_zIndex.default.progressIndicator = (0, _zIndex.setAbove)();
_zIndex.default.footer = (0, _zIndex.setAbove)();
_zIndex.default.scrollToTopButton = (0, _zIndex.setAbove)();
_zIndex.default.filterBars = (0, _zIndex.setAbove)();
_zIndex.default.dropDownMenu = (0, _zIndex.setAbove)();
_zIndex.default.dropDownMenuModal = (0, _zIndex.setAbove)();
_zIndex.default.mobileDropDownMenu = (0, _zIndex.setAbove)();
_zIndex.default.navMenuItemsMobile = (0, _zIndex.setAbove)();
_zIndex.default.header = (0, _zIndex.setAbove)();
_zIndex.default.navMenuItemsDesktop = (0, _zIndex.setAbove)();
_zIndex.default.modal = (0, _zIndex.setAbove)();
_zIndex.default.anchorModal = (0, _zIndex.setAbove)();
_zIndex.default.anchorModalContent = (0, _zIndex.setAbove)();

var chZindex = _objectSpread({}, _zIndex.default);

var _default = chZindex;
exports.default = _default;